import React, { Fragment } from 'react';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import { Button, ButtonRow, ComponentError } from '@gtintel/platform-atoms';
import PropertiesCard from '../../AssignmentsApp/PropertiesCard';
import { AssignmentContext } from '../../AssignmentsApp/context';
import { ReportContext } from '../context';

// const PreviewReportFragment = ({ f }: { f: ReportFragment }) => {
//   const [css, theme] = useStyletron();

//   return (
//     <div>
//       <div>Author: {f.author.name}</div>
//       <div
//         className={css({ ...theme.borders.border100 })}
//         key={f.id}
//         dangerouslySetInnerHTML={{ __html: f.unsafe_body }}
//       />
//     </div>
//   );
// };

const ReportNodeEditor = ({
  pathPrefix,
  node,
  preview = true
}) => {
  const key = `${pathPrefix}/${node.path}`;
  const [css, theme] = useStyletron();
  return <Fragment key={key}>
      <div className={css({
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    })}>
        <Heading>{node.name}</Heading>
        {node.data.is_automated && <span className={css({
        backgroundColor: theme.colors.backgroundWarning,
        color: theme.colors.contentPrimary,
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontWeight: 600,
        whiteSpace: 'nowrap'
      })}>
            Automated
          </span>}
      </div>
      {!preview && node.data.instructionsHtml && <div dangerouslySetInnerHTML={{
      __html: node.data.instructionsHtml
    }}></div>}
      <div className={css({
      marginLeft: '1em'
    })}>
        <HeadingLevel>
          {/* {(node.data.fragments || []).map((f) =>
            preview ? (
              <PreviewReportFragment key={f.id} f={f} />
            ) : (
              <ReportFragmentEditor key={f.id} fragment={f} />
            )
           )} */}
          {node.children.map(f => <ReportNodeEditor preview={preview} key={f.path} pathPrefix={key} node={f} />)}
        </HeadingLevel>
      </div>
    </Fragment>;
};

// const ReportFragmentEditor = ({ fragment }: { fragment: ReportFragment }) => {
//   const { updateFragment, isReadOnly } = React.useContext(ReportContext);
//   return (
//     <React.Fragment>
//       <Heading>{fragment.author.name}</Heading>
//       <Editor
//         readOnly={isReadOnly()}
//         onChange={(value: string) => {
//           updateFragment(fragment.id, value);
//         }}
//         value={fragment.unsafe_body}
//       />
//     </React.Fragment>
//   );
// };

export default ({
  hideDetails = false
}) => {
  const ref = React.useRef(null);
  const ctx = React.useContext(ReportContext);
  const assignmentCtx = React.useContext(AssignmentContext);
  const root = ctx.report();
  const [preview, setPreview] = React.useState(hideDetails);
  if (!assignmentCtx) {
    console.error('AssignmentContext is missing. Component likely added without an upstream context');
    return <ComponentError errorText="Assignments could not be loaded. Contact an admin." />;
  }
  return <div>
      <PropertiesCard />

      <ButtonRow flexPosition="flex-end">
        <Button kind="primary" onClick={() => setPreview(!preview)} testId="toggle-scope-details-button">
          <span>{preview ? 'Show scope details' : 'Hide scope details'}</span>
        </Button>
      </ButtonRow>

      <div ref={ref}>
        <HeadingLevel>
          <ReportNodeEditor preview={preview} pathPrefix={root.path} node={root} />
        </HeadingLevel>
      </div>
    </div>;
};